<template>
  <div>

    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.2
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

    <!-- <div class="allreports">
      <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
      :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
      :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" 
      :bgimage="bgimage" :showbg="showbg" :showrptfulltext="showrpttext"
      />
    </div> -->
  
    <section class="recentdocsec">
      <div class="recentdocdiv">
        <div class="recentdocinnerdiv">
          <div class="rpttitle1">Recent Documents</div>
          <div class="row align-items-start">
            <div class="col-xs-12 col-sm-12 col-md-4"  v-for="rpt in reportpresentation">
              <div>
                <ul>
                  <li class="linkformat1"><i class="fa-solid fa-file-circle-check" style="font-size: 20px; padding-right: 10px; color:rgb(152, 165, 172);"></i>
                    <a :href="`${ myPicUrl }${ rpt.rppdfpath }`" class="linkformat">{{ rpt.rptitle }}</a><br />
                    <span class="datecss">{{ dateTime(rpt.rpdate)}}</span>
                    <div v-html="rpt.rptfulltext"></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="passreports">
      <div class="recentdocdiv">
        <div class="recentdocinnerdiv">
          <div class="rpttitle1">Past Reports & Documents</div>
            <div class="yeardiv">
              <div  v-for="year in pyear" class="yearspan card shadow" @click="getId(myId=`${year.yearid}`, $event)"
               :id="`pitdiv${year.yearid}`"
              >
                {{ year.yeardesc }}
              </div>
              <div class="tablediv">
                <table class="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Report Description</th>
                      <th scope="col">Download Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="rptyr in getreportbyyears">
                      <td class="tdlinkcss"><a :href="`${myPicUrl}${rptyr.rppdfpath}`" class="tdlinkcss">{{ rptyr.rptitle}}</a></td>
                      <td><a :href="`${myPicUrl}${rptyr.rppdfpath}`" class="tdlinkcss"><i class="fa-solid fa-file-arrow-down" style="font-size: 30px;"></i></a></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
      </div>
    </section>
  
    <section class="goalsperfsec">
      <div class="goalsandperf">
        <div class="goalspeftitle">{{goals_and_performance_title}}</div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <div class="linktextformat"><router-link :to="{path: gplinkhref}" class="formatsustlinks">{{ gplinkname }}</router-link></div>
            <div v-html="goals_and_perf_Text"></div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6">
            <div class="linktextformat"><router-link :to="{path: unlinkhref}" class="formatsustlinks">{{ unlinkname }}</router-link></div>
            <div v-html="un_text"></div>
          </div>
        </div>
      </div>
      
    </section> -->

  </div>
</template>

<script>

import AllReports from '@/components/AllReports.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
require('@/globalDeclare.js');
import axios from 'axios';
import moment from 'moment';


export default {
  name: 'AboutView',
  components: {
  AllReports
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  myPicUrl: '',

  reportpresentation: [],
  reportcnt: '',
  lastrecordsreportpresent: [],
  rppdfpath: '',
  rptitle: '',
  rpdate: '',
  rplinkname: '',
  rptfulltext: '',
  rpcoverpageimagepath: '',
  singlereporttitle: '',
  rplinkname: '',
  rpdate: '',
  bgimage: '',

  showrpttext: false,
  showbg: false,

  pyear: [],
  getreportbyyears: [],
  goals_and_performance_title: '',
  goals_and_perf_Text: '',
  un_text: '',
  gplinkname: '',
  gplinkhref: '',
  unlinkname: '',
  unlinkhref: '',
  }
},
methods: {
  //method to format dates. please install moment using npm i moment
  dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
  async getId(myId, $event){
    let id = myId;
    let eid = $event.target.id;
    var myVueElement = document.getElementById("pitdiv" + id);
    let x = document.getElementsByClassName("activeElement");
    if(x.length > 0) { x[0].classList.remove("activeElement"); }
    myVueElement.classList.add("activeElement")
   

    await axios.get(`getallreportyears/${id}`).then(
    response => {
        this.getreportbyyears = response.data        
  })
  .catch((error) => {
      console.log(error)
    })

  },
},
async mounted() {
  this.myPicUrl = myUrlPath
  

   await axios.get('allpagespv/sustainabilityreporting').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
        console.log(error)
      })

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/sustainabilityreporting').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.bgimage = response.data.bgimage
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        this.showrpttext = response.data.showrptfulltext
        this.bgimage = response.data.bgimage
        this.showbg = response.data.showbgimage
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })

  //------------YEARS---------------
  await axios.get('getallyears/').then(
    response => {
        this.pyear = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------YEARS---------------
  await axios.get('getsustainabilityoverview/').then(
    response => {
        this.sustaininfo = response.data
        this.goals_and_performance_title = response.data[0].goals_and_performance_title
        this.goals_and_perf_Text = response.data[0].goals_and_perf_Text
        this.un_text = response.data[0].un_text
        this.gplinkname = response.data[0].gplinkname
        this.gplinkhref = response.data[0].gplinkhref
        this.unlinkname = response.data[0].unlinkname
        this.unlinkhref = response.data[0].unlinkhref
  })
  .catch((error) => {
      console.log(error)
    })

}
}
</script>

<style scoped>

.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}



.rpttitle, .rpttitle1 {
  font-size: 30px;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  text-align: center;
  padding: 20px;
  font-weight: bolder;
  color: goldenrod;
}


.rplname {
  padding-top: 40px;
  color:rgb(24, 74, 121);
  font-weight: bold;
}
.linkformat {
  text-decoration: none;
  color:rgb(24, 74, 121);
  font-weight: bold;
  font-size: 20px;
}
.linkformat1 {
  list-style-type: none;
}


/*Reccent Documents*/
.recentdocdiv, .passreports {
 padding-bottom: 100px;
 padding-top: 50px;
 
}
.recentdocsec {
  padding: 100px;
  background-color: whitesmoke;
}
.yearspan {
  float: left; 
  width: 120px; 
  color:rgb(152, 165, 172);
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
  margin-left: 5px;
  margin-top:10px;
}
.yeardiv {
  text-align: center; 
}
.tablediv {
  padding-top: 200px;
  overflow-x: scroll;
  width: 100%;
}

.table {
  margin-top: 100px; 
  width: 100%;
}
.tdlinkcss {
  text-align: left;
  text-decoration: none;
}
.goalsandperf{
  padding-top: 100px;
  padding-bottom: 100px;
}
.goalsperfsec {
  background-color: whitesmoke;
}
.goalspeftitle {
  font-size: 30px;
  font-weight: bold;
  color:rgb(152, 165, 172);
  padding-bottom: 50px;
}
.activeElement {
  background-color: red;
  font-weight:bold;
}
.allreports {
  margin-top: 340px;
}
.formatsustlinks{
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  color: rgb(130, 130, 145);
}
.linktextformat {
  text-align: center;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
 
  .reportdiv {
    padding: 20px;
    margin-top: 100px;
  }
  .yearspan {
    text-align: center;
  }
  .yeardiv {
    padding-left: 30px;
  }
  .tablediv {
    width: 96%;
    overflow-x: scroll;

  }
  .table {
    margin-top: -130px;
  }
  .goalsandperf{
    padding-left: 20px;
    padding-right: 20px;
  }
  .goalspeftitle {
    text-align: center;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
 
  .yearspan {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .tablediv {
    width: 98%;
    overflow-x: scroll;
    padding-left: 10px;
  }
  .table {
    margin-top: -130px;
  }
  .goalsandperf{
    padding-left: 40px;
    padding-right: 40px;
  }
  .goalspeftitle {
    text-align: center;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
 
  .yeardiv {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .tablediv {
    width: 100%;
    overflow-x: scroll;
    margin-top: -120px;
    padding-left: 10px;
  }
  .goalsandperf{
    padding-left: 60px;
    padding-right: 60px;
  }
 }

 /* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
 
  .middlecol {
    border-left: thin solid;
    border-right: thin solid;
    height: 370px;
  }
  .yeardiv {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .tablediv {
    width: 100%;
    overflow-x: scroll;
    margin-top: -120px;
    padding-left: 10px;
  }
  .reportdiv {
    padding: 100px;
    margin-top: 100px;
  }
  .imgwidth {
    width: 100%;
    padding-left: 30px;
    padding-right: 30px; 
  }
 }


 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
 
  .yeardiv {
    padding-left: 200px;
  }
  .tablediv {
    width: 100%;
    overflow-x: scroll;
    margin-top: -120px;
    padding-left: 10px;
  }
  .reportdiv {
    padding: 100px;
    margin-top: 100px;
  }

 } 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
 
  .yeardiv {
    padding-left: 130px;
  }
  .tablediv {
    width: 93%;
    overflow-x: scroll;

  }
  .table {
    margin-top: -130px;
  }
  .goalsandperf{
    padding-left: 200px;
    padding-right: 200px;
  }


}

  
@media only screen and (min-width: 1600px) {

  } 
</style>
